import { createSlice, createAction } from '@reduxjs/toolkit'
import moment from 'moment-timezone'

import { dateRangeConst } from 'constants/dateRangeConstants'
import { mappingDataForConsamptionCharts } from 'utils/mappingDataForConsamptionCharts'

const initialState = {
  perfomanceData: {
    power_usage: null,
    power_usage_limits: [],
    power_factory: null,
    power_factory_limits: [],
    voltage_min: null,
    voltage_max: null,
    frequency_min: null,
    frequency_max: null,
    voltage_limits: [],
    frequency_limits: [],
  },
  isFetchingPerfomance: false,
  facilityList: [],
  currentFacility: {
    id: null,
    name: '',
    area: null,
    latitude: null,
    longitude: null,
    group: {
      id: null,
      name: '',
      image_uri: null,
      created_at: null,
    },
    category: '',
    image_uri: null,
    total_connected_load: null,
    timezone: null,
    city: {
      id: null,
      name: '',
      latitude: null,
      longitude: null,
    },
    created_by_id: null,
    current_temperature: 0,
    created_at: null,
    updated_at: null,
  },
  isFetching: false,
  isFetchingChartAreaData: false,
  error: {
    message: '',
    code: '',
  },
  currentFacilityGlobalData: {
    items: [],
  },
  selectedDateRange: {
    id: dateRangeConst.today.id,
    label: dateRangeConst.today.label,
    value: {
      start_timestmp: moment().startOf('day').utc().unix(),
      end_timestmp: moment().endOf('day').utc().unix(),
    },
  },
  facilityId: '',
  lastUpdateDate: null,
  heatMapData: [],
  heatMapSelectedTimeStamp: moment().unix(),
  isFetchingHeatMap: false,
}

export const getHeatmapSelectedTimeStampSelector = (state) =>
  state.facility.heatMapSelectedTimeStamp

export const getIsFetchingHeatMapSelector = (state) =>
  state.facility.isFetchingHeatMap

export const getHeatMapDataSelector = (state) => state.facility.heatMapData

export const getPerfomanceDataSelector = (state) =>
  state.facility.perfomanceData
export const getIsFetchingPerfomance = (state) =>
  state.facility.isFetchingPerfomance

export const getIsFetchingChartAreaDataSelector = (state) =>
  state.facility.isFetchingChartAreaData

export const getLastUpdateDateSelector = (state) =>
  state.facility.lastUpdateDate

export const getFacilityDataSelector = (state) => state.facility.currentFacility
export const selectIsFetchingFacility = (state) => state.facility.isFetching
export const selectConsumptionFacility = (state) =>
  state.facility.currentFacilityGlobalData

export const getFacilityIdSelector = (state) => state.facility.facilityId

export const getFacilityDateRangeSelector = (state) =>
  state.facility.selectedDateRange

export const getDataFacilityConsumptionCharts = (state) =>
  mappingDataForConsamptionCharts(
    state.facility.currentFacilityGlobalData?.items
  )

const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    setFacilityData(state, action) {
      state.currentFacility = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setIsFetchingFacility(state, action) {
      state.isFetching = action.payload
    },
    setCurrentFacilityData(state, action) {
      state.currentFacilityGlobalData = action.payload
    },
    setSelectedDateRange(state, action) {
      state.selectedDateRange = action.payload
      state.selectedDateRangeByPicker = initialState.selectedDateRangeByPicker
    },
    setFacilityId(state, action) {
      state.facilityId = action.payload
    },
    setLastUpdateDate(state, action) {
      state.lastUpdateDate = action.payload
    },
    setIsFetchingChartAreaData(state, action) {
      state.isFetchingChartAreaData = action.payload
    },
    setPerfomanceDate(state, action) {
      state.perfomanceData = action.payload
    },
    setIsFetchingPerfomance(state, action) {
      state.isFetchingPerfomance = action.payload
    },
    setHeatMapData(state, action) {
      state.heatMapData = action.payload
    },
    setIsFetchingHeatMap(state, action) {
      state.isFetchingHeatMap = action.payload
    },
    setHeatmapTimestamp(state, action) {
      state.heatMapSelectedTimeStamp = action.payload
    },
    setSelectedDateRangeRedirect(state, action) {
      state.selectedDateRange = action.payload
    },
    setDefaultDateSelect(state, action) {
      state.selectedDateRange = action.payload
    },
  },
})

export const getFacility = createAction('facility/getFacility')
export const getPerfomanceData = createAction('facility/getPerfomanceData')
export const getCurrentFacilityData = createAction(
  'facility/getCurrentFacilityData'
)
export const getHeatMapData = createAction('facility/getHeatMapData')

export const {
  setFacilityData,
  setError,
  setIsFetchingFacility,
  setCurrentFacilityData,
  setSelectedDateRange,
  setFacilityId,
  setSelectedDateRangeByPicker,
  setLastUpdateDate,
  setIsFetchingChartAreaData,
  setPerfomanceDate,
  setIsFetchingPerfomance,
  setHeatMapData,
  setIsFetchingHeatMap,
  setHeatmapTimestamp,
  setSelectedDateRangeRedirect,
  setDefaultDateSelect,
} = facilitySlice.actions

export default facilitySlice.reducer
